import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

export default class NewsFeedBaseAPI extends BaseAPI {
  constructor (controller?: string, entityName?: string) {
    super(controller, entityName, getApiUrl(apis.NewsFeedAPI))
  }
}
